import React, {
  useContext,
  useState,
  useEffect,
  useRef,
  useCallback,
} from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { DynamicContext } from "../../Context/DynamicContext";
import OptionData from "../../Assets/Json/StaticOptions.json";
import TextInput from "../../Common/TextInput/TextInput";
import Button from "../../Common/Button/Button";
import backArrowIcon from "../../Assets/Images/arrow-back-icon.png";
import SelectInput from "../../Common/Select-Input/SelectInput";
import CandidateLightIcon from "../../Assets/Images/candidates-header-icon.svg";
import CandidateDarkIcon from "../../Assets/Images/candidates-header-darkicon.svg";
import { Toast } from "../../Common/Toast-Snackbar/ToastSnackbar";
import { post, get } from "../../helper/Api_helper";
import {
  VYLABS_BASE_URL,
  MONSTER_SEARCH_BASE_URL,
  IRMT_CANDIDATE_SEARCH,
  IRMT_CANDIDATE_VIEW,
  IRMT_CANDIDATE_RECRUITER,
  IRMT_CANDIDATE_CALL_STAGE,
  IRMT_CANDIDATE_SEARCH_COUNTRY,
  GET_CANDIDATES_BY_NOTES,
  GET_CANDIDATE_BY_ID,
  CCREATE_CAN,
  UPDATE_CANDIDATE_DETAILS,
  VENDORS_SEARCH,
  GET_VENDOR_DETAILS_BY_ID,
  LINK_CANDIDATE_RESUME,
} from "../../helper/url_helper";
import Card from "../../Common/Card/Card";
import AnimationPlayer from "../../Common/Animation-Player/AnimationPlayer";
import VybogTALLoaderAnimation from "../../Common/Dynamic-Animations/DynamicAnimations";
import NoDataFound from "../../Assets/Json/nodata-found-robot-animation.json";
import SidePopup from "../../Common/SidePopup/SidePopup";
import CandidateDetailsContainer from "../../Common/Candidate-Details-Container/CandidateDetailsContainer";
import envConfig from "../../helper/env_config";
import DynamicSkeleton from "../../Common/Skeleton/Skeleton";
import DynamicMultipleSelectCheckmarks from "../Multiple-Select-Checkmarks/MultipleSelectCheckmarks";
import {
  downloadResumeFromPresignedUrl,
  parseIrmtResumeHeadless,
} from "./IrmtResumeParser";
import PhoneNumberInput from "../../Common/PhoneNumberInput/PhoneNumberInput";
import infoIcon from "../../Assets/Images/infoicon.svg";
import CustomTooltip from "../../Common/Tooltip/Tooltip";

const filterByOptions = [
  { label: "Tracked By", value: "ct_created" },
  { label: "Created By", value: "can_created" },
];

const monthOptions = Array.from({ length: 12 }, (_, i) => ({
  label: String(i),
  value: String(i),
}));

const yearOptions = Array.from({ length: 41 }, (_, i) => ({
  label: String(i),
  value: String(i),
}));

const timeframeOptions = [
  { label: "Last 1 year", value: "1" },
  { label: "Last 2 years", value: "2" },
  { label: "Last 3 years", value: "3" },
  { label: "Last 4 years", value: "4" },
  { label: "Last 5 years", value: "5" },
];
const INDIA_COUNTRY_CODE = "91";

function IrmtSearch() {
  const { isDarkMode, isVendorFeatureEnabled } = useContext(DynamicContext);
  const navigate = useNavigate();
  const { StaticOptions = {} } = OptionData || {};
  const { source = [] } = StaticOptions || {};
  const [results, setResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isProcessingView, setIsProcessingView] = useState(false);
  const [localCandidate, setLocalCandidate] = useState(null);
  const [allCountryData, setAllCountryData] = useState([]);
  const [abortController, setAbortController] = useState(null);
  const [recruiterOptions, setRecruiterOptions] = useState([]);
  const [callStageOptions, setCallStageOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [isEditingCandidate, setIsEditingCandidate] = useState(false);
  const [originalCandidateData, setOriginalCandidateData] = useState(null);
  const [editedCandidateData, setEditedCandidateData] = useState(null);
  const [vendorList, setVendorList] = useState([]);
  const [vendorOptionLoading, setVendorOptionLoading] = useState(false);
  const [locationOptions, setLocationOptions] = useState([]);
  const [residencyOptions, setResidencyOptions] = useState([]);
  const [assignedVendor, setAssignedVendor] = useState(null);
  const [showAdvancedSearch, setShowAdvancedSearch] = useState(false);
  const [hasCandidateId , setHasCandidateId] = useState(false);
  const [realCandidateId, setRealCandidateId] = useState();
  const [isImportFailed, setIsImportFailed] = useState(false);

  const toggleAdvancedSearch = () => setShowAdvancedSearch(!showAdvancedSearch);
  const observer = useRef();

  const validationSchema = Yup.object({
    skills: Yup.string().nullable(),
    fromDate: Yup.date().nullable(),
    toDate: Yup.date()
      .min(Yup.ref("fromDate"), "To Date cannot be before From Date")
      .nullable(),
    role: Yup.string().nullable(),
    country: Yup.string().nullable(),
  });

  const formik = useFormik({
    initialValues: {
      skills: "",
      fromDate: "",
      toDate: "",
      role: "",
      country: "",
      location: [],
      residency: [],
      filterby: "",
      canName: "",
      canEmail: "",
      canPhone: "",
      canSource: "",
      recruiter: "",
      callStage: "",
      jobOpenings: "",
      yearsOfExperience: "",
      expFromMonth: "",
      expFromYear: "",
      expToMonth: "",
      expToYear: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      const { fromDate, toDate, filterby } = values;
      const hasFromDate = !!fromDate;
      const hasToDate = !!toDate;
      const hasFilterBy = !!filterby;

      if (
        (hasFromDate || hasToDate || hasFilterBy) &&
        !(hasFromDate && hasToDate && hasFilterBy)
      ) {
        Toast("error", "Please fill From Date, To Date, and Filter By");
        return;
      }

      setPage(1);
      setHasSearched(true);
      handleSearch(1);
    },
  });
  const isIndiaCountrySelected =
    String(formik.values.country) === INDIA_COUNTRY_CODE;

  useEffect(() => {
    const fetchCountryLocationResidencyOptions = async () => {
      try {
        const response = await get(
          MONSTER_SEARCH_BASE_URL,
          IRMT_CANDIDATE_SEARCH_COUNTRY,         
        );
        const countryData = response?.countries || [];
        setAllCountryData(countryData);
        const allowedCountryCodes = [1, 65, 91, 10];
        const apiCountries = (countryData || [])
          .filter(
            (c) =>
              c &&
              c.name != null &&
              c.code != null &&
              allowedCountryCodes.includes(c.code),
          )
          .map((c) => ({
            label: String(c.name),
            value: String(c.code),
          }));
        setCountryOptions(apiCountries);

        const uniqueLocations = new Set();
        const allLocations = countryData.flatMap(
          (country) => country.location || [],
        );
        const safeApiLocations = allLocations
          .filter((loc) => loc && loc.loc_name != null && loc.loc_id != null)
          .filter((loc) => {
            const key = `${loc.loc_name}-${loc.loc_id}`;
            if (uniqueLocations.has(key)) return false;
            uniqueLocations.add(key);
            return true;
          })
          .map((loc) => ({
            label: String(loc.loc_name),
            value: String(loc.loc_id),
          }));
        setLocationOptions(safeApiLocations);

        const uniqueResidencies = new Set();
        const allResidencies = countryData.flatMap(
          (country) => country.residency || [],
        );
        const apiResidencies = allResidencies
          .filter((res) => {
            const key = `${res.res_name}-${res.res_id}`;
            if (uniqueResidencies.has(key)) return false;
            uniqueResidencies.add(key);
            return true;
          })
          .filter((res) => res && res.res_name != null && res.res_id != null)
          .map((res) => ({
            label: String(res.res_name),
            value: String(res.res_id),
          }));
        setResidencyOptions(apiResidencies);
      } catch (error) {
        console.error(
          "Error fetching IRMT country, location, or residency data:",
          error,
        );
      }
    };
    fetchCountryLocationResidencyOptions();
  }, []);

  useEffect(() => {
    if (formik.values.country && allCountryData.length > 0) {
      const selectedCountryCode = parseInt(formik.values.country, 10);
      const selectedCountryData = allCountryData.find(
        (c) => c.code === selectedCountryCode,
      );

      if (selectedCountryData) {
        const filteredLocations = (selectedCountryData.location || []).map(
          (loc) => ({ label: String(loc.loc_name), value: String(loc.loc_id) }),
        );
        setLocationOptions(filteredLocations);

        const filteredResidencies =
          selectedCountryCode === Number(INDIA_COUNTRY_CODE)
            ? []
            : (selectedCountryData.residency || []).map((res) => ({
                label: String(res.res_name),
                value: String(res.res_id),
              }));
        setResidencyOptions(filteredResidencies);
      } else {
        setLocationOptions([]);
        setResidencyOptions([]);
      }
      formik.setFieldValue("location", []);
      formik.setFieldValue("residency", []);
    } else if (!formik.values.country) {
      setLocationOptions([]);
      setResidencyOptions([]);
      formik.setFieldValue("location", []);
      formik.setFieldValue("residency", []);
    }
  }, [formik.values.country, allCountryData, formik.setFieldValue]);

  useEffect(() => {
    const fetchRecruiters = async () => {
      try {
        const response = await get(
          MONSTER_SEARCH_BASE_URL,
          IRMT_CANDIDATE_RECRUITER,         
        );
        const parsed =
          typeof response === "string" ? JSON.parse(response) : response;
        const recruiterData = parsed?.recruiters || [];

        const options = recruiterData.map((recruiter) => ({
          label: recruiter.username ? recruiter.username.trim() : "N/A",
          value: recruiter.usr_id,
        }));

        setRecruiterOptions(options);
      } catch (error) {
        console.error("Error fetching IRMT recruiters:", error);
      }
    };
    fetchRecruiters();
  }, []);

  useEffect(() => {
    const fetchCallStages = async () => {
      try {
        const response = await get(
          MONSTER_SEARCH_BASE_URL,
          IRMT_CANDIDATE_CALL_STAGE,         
        );
        const callStageData = response?.call_stage || [];
        const options = callStageData.map((stage) => ({
          label: stage.cstg_name,
          value: stage.cstg_id,
        }));
        setCallStageOptions(options);
      } catch (error) {
        console.error("Error fetching IRMT_CANDIDATE_CALL_STAGES:", error);
      }
    };
    fetchCallStages();
  }, []);

  const handleSearch = async (pageNum = 1) => {
    if (pageNum === 1) {
      setIsLoading(true);
      setResults([]);
    } else {
      setIsLoadingMore(true);
    }
    try {
      const params = new URLSearchParams();
      params.append("skill", formik.values.skills);
      if (formik.values.fromDate)
        params.append("fromDate", formik.values.fromDate);
      if (formik.values.toDate) params.append("toDate", formik.values.toDate);
      if (formik.values.role) params.append("role", formik.values.role);
      if (formik.values.country)
        params.append("country", formik.values.country);
      if (formik.values.filterby)
        params.append("filterBy", formik.values.filterby);
      if (formik.values.location && formik.values.location.length > 0) {
        params.append("loc_id", formik.values.location.join(","));
      }
      if (formik.values.residency && formik.values.residency.length > 0) {
        params.append("res_id", formik.values.residency.join(","));
      }
      if (formik.values.canName)
        params.append("can_name", formik.values.canName);
      if (formik.values.canPhone)
        params.append("can_phone", formik.values.canPhone);
      if (formik.values.canSource)
        params.append("can_source", formik.values.canSource);
      if (formik.values.recruiter)
        params.append("recruiter", formik.values.recruiter);
      if (formik.values.callStage)
        params.append("cstg_id", formik.values.callStage);
      if (formik.values.jobOpenings)
        params.append("job_title", formik.values.jobOpenings);
      if (formik.values.yearsOfExperience)
        params.append("year", formik.values.yearsOfExperience);
      if (formik.values.expFromMonth)
        params.append("expfm", formik.values.expFromMonth);
      if (formik.values.expFromYear)
        params.append("expfy", formik.values.expFromYear);
      if (formik.values.expToMonth)
        params.append("exptm", formik.values.expToMonth);
      if (formik.values.expToYear)
        params.append("expty", formik.values.expToYear);
      if (formik.values.canEmail)
        params.append("can_email", formik.values.canEmail);

      params.append("page", pageNum);
      params.append("pageSize", 25);

      const response = await get(
        MONSTER_SEARCH_BASE_URL,
        `${IRMT_CANDIDATE_SEARCH}?${params.toString()}`,       
      );
      const parsedResponse =
        typeof response === "string" ? JSON.parse(response) : response;
      let searchData = parsedResponse?.response?.data || [];

      if (typeof searchData === "string") {
        try {
          searchData = JSON.parse(searchData);
        } catch (e) {
          console.error("Failed to parse nested IRMT candidate data:", e);
        }
      }

      const newData = Array.isArray(searchData) ? searchData : [];
      setResults((prev) => (pageNum === 1 ? newData : [...prev, ...newData]));
      setHasMore(newData.length === 25);
    } catch (error) {
      console.error("IRMT Search Error:", error);
      Toast("error", "Failed to search candidates. Please try again.");
    } finally {
      setIsLoading(false);
      setIsLoadingMore(false);
    }
  };

  const loadMoreIrmtResults = async () => {
    if (isLoadingMore || isLoading) return;
    const nextPage = page + 1;
    setPage(nextPage);
    await handleSearch(nextPage);
  };

  const lastIrmtCardRef = useCallback(
    (node) => {
      if (isLoading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && hasMore) {
            loadMoreIrmtResults();
          }
        },
        { root: null, rootMargin: "100px", threshold: 0.1 },
      );

      if (node) observer.current.observe(node);
    },
    [isLoading, hasMore, loadMoreIrmtResults],
  );

  const transformIrmtToCandidate = (profile, canId, trackHistory = []) => {
    const name = profile.can_name || profile.name || "";
    const email = profile.can_email || "";
    const phone = profile.can_phone || profile.phone || "";
    const rawExperience =
      profile.can_exp_year ||
      profile.years_of_experience ||
      profile.experience ||
      null;
    const experience = !isNaN(parseFloat(rawExperience))
      ? parseFloat(rawExperience)
      : null;

    const skills =
      typeof profile.skill === "string"
        ? profile.skill
            .split(",")
            .map((s) => s.trim())
            .filter(Boolean)
        : Array.isArray(profile.skills)
          ? profile.skills
          : [];

    const parsedResumeData = {
      BasicInfo: {
        Name: name,
        Email: email,
        Phone: phone,
        PhoneNumber: phone,
        YearsOfExperience: experience,
        SecondaryEmail: profile.can_additional_email || "",
        CurrentLocationCity: profile.city || profile.location || "",
        CurrentLocationCountry: profile.country_name || profile.country || "",
      },
      Skills: skills,
      CareerHistory: {
        JobDetails: Array.isArray(profile.experience_details)
          ? profile.experience_details.map((exp) => ({
              JobOpenings: exp.designation || exp.role || "",
              JobCompany: exp.company_name || "",
              Description: exp.job_description || "",
              StartDate: exp.from_date || "",
              EndDate: exp.to_date || "",
            }))
          : [],
      },
      EducationHistory: Array.isArray(profile.education_details)
        ? profile.education_details.map((edu) => ({
            Institute: edu.college_name || "",
            Degree: edu.degree || "",
            GraduationDate: edu.passed_out_year || "",
          }))
        : [],
    };

    return {
      id: `temp_irmt_${canId}`,
      name,
      email,
      phone,
      secondaryEmail: profile.can_additional_email || "",
      designation: profile.designation || profile.role || "",
      city: profile.city || profile.location || "",
      country: profile.country_name || profile.country || "",
      experience: experience,
      created_at: profile.created_date || "",
      updated_at: profile.last_trackdate || "",
      recruiter: profile.recruiter || "",
      call_stage: profile.call_stage || "",
      remarks: profile.remarks || "",
      source_name: profile.can_source || "",
      job_title: profile.job_title || "",
      track_history: Array.isArray(trackHistory) ? trackHistory : [],
      parsedResumeData,
      skills,
      source: "IRMT",
      isTransformed: true,
      shouldSkipFetch: true,
      notes: `irmt_${canId}`,
      vendorID: envConfig.irmtCandidateVendorId,
      isLoadingResume: true,
      isTempCandidate: true,
    };
  };

  const fetchCandidateDetails = async (id) => {
    try {
      const response = await get(
        VYLABS_BASE_URL,
        `${GET_CANDIDATE_BY_ID}?id=${id}`,
      );
      const candidate = response?.candidate;
      if (!candidate) return null;

      const candidatefiles = response?.files || [];
      const parsedResumeData = candidate?.parsed_resume
        ? JSON.parse(candidate.parsed_resume)
        : null;
      const fullCandidate = {
        ...candidate,
        vendorID: candidate.vendor_id,
        parsedResumeData,
        files: candidatefiles,
        presignedUrl: candidatefiles[0]?.presigned_url || null,
        isFileBased: false,
        avatar: response?.profile_img_url,
      };

      if (fullCandidate.vendorID) {
        try {
          const vendorResponse = await get(
            VYLABS_BASE_URL,
            `${GET_VENDOR_DETAILS_BY_ID}?id=${fullCandidate.vendorID}`,
          );
          setAssignedVendor(vendorResponse);
          fullCandidate.vendorDetails = vendorResponse?.vendor || null;
        } catch (err) {
          console.error("Error fetching vendor details:", err);
          fullCandidate.vendorDetails = null;
          setAssignedVendor(null);
        }
      } else {
        fullCandidate.vendorDetails = null;
        setAssignedVendor(null);
      }

      return fullCandidate;
    } catch (error) {
      console.error("Error fetching parsed candidate:", error);
      return null;
    }
  };

  const retryFetchCandidate = async (
    candidateId,
    attempts = 5,
    delayMs = 5000,
    signal = null,
  ) => {
    for (let i = 0; i < attempts; i++) {
      if (signal?.aborted) return null;
      const full = await fetchCandidateDetails(candidateId);
      if (full?.id) return full;
      await new Promise((resolve) => setTimeout(resolve, delayMs));
    }
    return null;
  };

  const upsertCandidateFromIrmtData = async (
    parseResult,
    candidateId,
    displayCandidate,
    signal,
  ) => {
    const basePayload = {
      name: displayCandidate.name,
      email: displayCandidate.email,
      phone: displayCandidate.phone,
      skills: displayCandidate.skills,
      city: displayCandidate.city,
      country: displayCandidate.country,
      designation: displayCandidate.designation,
      yearsOfExperience: displayCandidate.experience,
      vendorID: envConfig.irmtCandidateVendorId,
      status: "New Profile",
      notes: `irmt_${candidateId}`,
      source: "IRMT",
    };

    Object.keys(basePayload).forEach((key) => {
      if (basePayload[key] === "" || basePayload[key] == null) {
        delete basePayload[key];
      }
    });

    if (parseResult?.candidateId) {
      await post(
        VYLABS_BASE_URL,
        UPDATE_CANDIDATE_DETAILS,
        {
          ...basePayload,
          id: parseResult.candidateId,
        },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        },
      );
      return parseResult.candidateId;
    }

    if (parseResult?.status === "INCOMPLETE") {
      const response = await post(VYLABS_BASE_URL, CCREATE_CAN, {
        ...basePayload,
        fileID: parseResult.fileID,
      });
      return response?.id || null;
    }

    if (parseResult?.status === "FAILED") {
      const response = await post(VYLABS_BASE_URL, CCREATE_CAN, basePayload);
      if (response?.id && parseResult?.fileID) {
        await post(VYLABS_BASE_URL, LINK_CANDIDATE_RESUME, {
          candidate_id: response.id,
          file_id: parseResult.fileID,
        });
      }
      return response?.id || null;
    }

    if (!parseResult?.candidateId) {
      const response = await post(VYLABS_BASE_URL, CCREATE_CAN, basePayload);
      return response?.id || null;
    }

    if (signal?.aborted) return null;
    return null;
  };

  const startBackgroundIrmtResumeParsing = async (
    candidateId,
    profile,
    signal,
    displayCandidate,
  ) => {
    try {
      let resumeFile = null;
      const candidateFileName = displayCandidate?.name
        ? displayCandidate.name.replace(/\s+/g, "_")
        : "candidate_resume";

      if (profile?.presignedurl) {
        resumeFile = await downloadResumeFromPresignedUrl(
          profile.presignedurl,
          profile?.can_resume_path || profile?.cr_resume_path || "",
          candidateFileName,
        );
      } else if (profile?.resume_blob) {
        try {
          resumeFile = base64ToFileStrict(
            profile.resume_blob,
            candidateFileName,
          );
        } catch (error) {
          console.error("Resume blob conversion failed:", error);
          throw new Error("Failed to process resume_blob");
        }
      }

      if (!resumeFile) {
        if (
          !displayCandidate?.name ||
          (!displayCandidate?.email && !displayCandidate?.phone)
        ) {
          setLocalCandidate((prev) => ({
            ...prev,
            isLoadingResume: false,
          }));
          setIsImportFailed(true);
          return;
        }

        const createdId = await upsertCandidateFromIrmtData(
          { status: "FAILED" },
          candidateId,
          displayCandidate,
          signal,
        );
        if (!createdId || signal?.aborted) {
          setLocalCandidate((prev) => ({ ...prev, isLoadingResume: false }));
          return;
        }
        if(createdId) {
          setHasCandidateId(true);
          setRealCandidateId(createdId);
        }
        const full = await retryFetchCandidate(createdId, 5, 5000, signal);
        setLocalCandidate((prev) => ({
          ...prev,
          ...(full || {}),
          isLoadingResume: false,
          isTempCandidate: false,
        }));
        return;
      }

      const parseResult = await parseIrmtResumeHeadless(resumeFile, { signal });
      if (signal?.aborted) return;

      if (
        (parseResult?.status === "INCOMPLETE" ||
          parseResult?.status === "FAILED") &&
        (
          !displayCandidate?.name ||
          (!displayCandidate?.email && !displayCandidate?.phone)
        )
      ) {
        setLocalCandidate((prev) => ({
          ...prev,
          isLoadingResume: false,
        }));
        setIsImportFailed(true);
        return;
      }

      const finalCandidateId = await upsertCandidateFromIrmtData(
        parseResult,
        candidateId,
        displayCandidate,
        signal,
      );
      if (!finalCandidateId || signal?.aborted) {
        if (
          !displayCandidate?.name ||
          (!displayCandidate?.email && !displayCandidate?.phone)
        ) {
          setIsImportFailed(true);
        }
        setLocalCandidate((prev) => ({ ...prev, isLoadingResume: false }));
        return;
      }
      if(finalCandidateId) {
        setHasCandidateId(true);
        setRealCandidateId(finalCandidateId);
      }
      const full = await retryFetchCandidate(finalCandidateId, 5, 5000, signal);
      if (signal?.aborted) return;
      setLocalCandidate((prev) => ({
        ...prev,
        ...(full || {}),
        isLoadingResume: false,
        isTempCandidate: false,
      }));
    } catch (error) {
      if (signal?.aborted) return;
      console.error("IRMT background parsing failed:", error);
      setLocalCandidate((prev) => ({ ...prev, isLoadingResume: false }));
    }
  };

  const base64ToFileStrict = (base64String, defaultName = "resume") => {
    if (!base64String) {
      throw new Error("Empty resume_blob");
    }

    const mimeMap = {
      pdf: "application/pdf",
      doc: "application/msword",
      docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      txt: "text/plain",
      rtf: "application/rtf",
    };

    const reverseMimeMap = Object.fromEntries(
      Object.entries(mimeMap).map(([ext, mime]) => [mime, ext]),
    );

    let mime = "application/octet-stream";
    let base64Data = base64String;

    if (base64String.includes(",")) {
      const arr = base64String.split(",");
      base64Data = arr[1];

      const mimeMatch = arr[0].match(/:(.*?);/);
      if (mimeMatch) {
        mime = mimeMatch[1];
      }
    }

    const ext = reverseMimeMap[mime] || "bin";
    const bstr = atob(base64Data);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    const fileName = `${defaultName}.${ext}`;

    return new File([u8arr], fileName, { type: mime });
  };

  const fetchVendors = async (inputValue = "") => {
    try {
      setVendorOptionLoading(true);
      const response = await get(
        VYLABS_BASE_URL,
        `${VENDORS_SEARCH}?vendor_name=${encodeURIComponent(inputValue)}`,
      );

      const { vendors = [] } = response;
      const fetchedVendors = Array.isArray(vendors)
        ? vendors
            .filter((v) => v?.id && v?.name)
            .map((v) => ({
              label: v.contact_person
                ? `${v.name} - ${v.contact_person}`
                : v.name,
              value: v.id,
            }))
        : [];

      setVendorList(fetchedVendors);
    } catch (err) {
      console.error("fetchVendors error", err);
      setVendorList([]);
    } finally {
      setVendorOptionLoading(false);
    }
  };

  const handleVendorInputChange = (_, value) => {
    if (value && value.length >= 3) {
      fetchVendors(value);
    } else {
      setVendorList([]);
    }
  };

  const handleEditCandidate = () => {
    if (!localCandidate) return;

    if (localCandidate?.isTempCandidate || localCandidate?.isLoadingResume) {
      Toast("error", "Please wait until candidate is saved.");
      return;
    }

    const getValidExperience = (value) => {
      const num = Number(value);
      if (isNaN(num)) return "";
      if (num < 0) return 0;
      return num;
    };

    const experienceValue = getValidExperience(
      localCandidate?.experience ?? localCandidate?.yearsOfExperience,
    );

    const formattedCandidate = {
      ...localCandidate,
      name: localCandidate.name || "",
      email: localCandidate.email || "",
      phone: localCandidate.phone || "",
      skills: Array.isArray(localCandidate.skills)
        ? localCandidate.skills
        : localCandidate.parsedResumeData?.Skills || [],
      designation: localCandidate.designation || "",
      experience: experienceValue,
      city: localCandidate.city || "",
      state: localCandidate.state || "",
      country: localCandidate.country || "",
      vendorID: localCandidate.vendorID || "",
    };

    setOriginalCandidateData({ ...localCandidate });
    setEditedCandidateData(formattedCandidate);
    setIsEditingCandidate(true);
  };

  const handleCandidateChange = (data) => {
    setEditedCandidateData((prev) => ({ ...prev, ...data }));
  };

  const saveCandidateChanges = async () => {
    if (!editedCandidateData) {
      Toast("error", "No changes to save");
      return;
    }

    try {
      const token = localStorage.getItem("token");
      if (!token) {
        Toast("error", "Unauthorized");
        return;
      }

      const candidateData = { id: localCandidate.id };

      Object.keys(editedCandidateData).forEach((key) => {
        if (editedCandidateData[key] !== originalCandidateData[key]) {
          candidateData[key] = editedCandidateData[key];
        }
      });

      if (Object.keys(candidateData).length === 1) {
        Toast("info", "No changes were made.");
        setIsEditingCandidate(false);
        return;
      }

      Object.keys(candidateData).forEach((key) => {
        if (key === "preferredSalary") {
          candidateData[key] = Number(candidateData[key]);
        }
      });

      if (candidateData.experience !== undefined) {
        candidateData.yearsOfExperience = Number(candidateData.experience);
        delete candidateData.experience;
      }
      Object.keys(candidateData).forEach((key) => {
        if (candidateData[key] === "" || candidateData[key] == null) {
          delete candidateData[key];
        }
      });
      const response = await post(
        VYLABS_BASE_URL,
        UPDATE_CANDIDATE_DETAILS,
        candidateData,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (response) {
        const updatedCandidate = { ...localCandidate, ...candidateData };

        if (
          candidateData.vendorID !== undefined &&
          candidateData.vendorID !== localCandidate.vendorID
        ) {
          if (candidateData.vendorID) {
            try {
              const vendorResponse = await get(
                VYLABS_BASE_URL,
                `${GET_VENDOR_DETAILS_BY_ID}?id=${candidateData.vendorID}`,
              );
              updatedCandidate.vendorDetails = vendorResponse?.vendor || null;
              setAssignedVendor(vendorResponse);
            } catch (err) {
              console.error("Error fetching vendor details:", err);
              updatedCandidate.vendorDetails = null;
              setAssignedVendor(null);
            }
          } else {
            updatedCandidate.vendorDetails = null;
            setAssignedVendor(null);
          }
        }
        setLocalCandidate(updatedCandidate);
        setIsEditingCandidate(false);
        setOriginalCandidateData(null);
        setEditedCandidateData(null);
        Toast("success", "Candidate updated successfully");
      }
    } catch (error) {
      console.error("Error updating candidate:", error);
      Toast("error", "Failed to update candidate");
    }
  };

  const resetCandidateEdit = () => {
    if (originalCandidateData) {
      setLocalCandidate(originalCandidateData);
    }
    setIsEditingCandidate(false);
    setOriginalCandidateData(null);
    setEditedCandidateData(null);
  };

  const handlePopupClose = () => {
    setHasCandidateId(false);
    setRealCandidateId();
    setIsImportFailed(false);
    if (abortController) {
      abortController.abort("Popup closed by user");
    }
    if (localCandidate?.files?.[0]?.localUrl) {
      URL.revokeObjectURL(localCandidate.files[0].localUrl);
    }
    setIsPopupOpen(false);
    setLocalCandidate(null);
    setIsProcessingView(false);
    setAbortController(null);
    setIsEditingCandidate(false);
    setOriginalCandidateData(null);
    setEditedCandidateData(null);
  };

  const handleViewCandidate = async (candidate) => {
    if (isProcessingView) {
      abortController?.abort();
    }

    const candidateId = candidate.can_id || candidate.id;
    if (!candidateId) {
      Toast("error", "Candidate ID is missing");
      return;
    }

    const controller = new AbortController();
    setAbortController(controller);
    setIsPopupOpen(true);
    setIsProcessingView(true);
    setLocalCandidate(null);

    try {
      const notes = `irmt_${candidateId}`;
      const token = localStorage.getItem("token");
      if (token) {
        try {
          const notesRes = await get(VYLABS_BASE_URL, GET_CANDIDATES_BY_NOTES, {
            params: { notes },
            headers: { Authorization: `Bearer ${token}` },
            signal: controller.signal,
          });
          if(notesRes?.candidate?.id) {
            setHasCandidateId(true);
            setRealCandidateId(notesRes?.candidate?.id);
          }
          const mappedId =
            (notesRes && notesRes.id) ||
            (notesRes && notesRes.candidate && notesRes.candidate.id) ||
            (Array.isArray(notesRes) && notesRes[0]?.id) ||
            null;
          if (mappedId && !controller.signal.aborted) {
            const full = await fetchCandidateDetails(mappedId);
            if (full) {
              setLocalCandidate(full);
              setIsProcessingView(false);
              return;
            }
          }
        } catch (lookupError) {
          if (controller.signal.aborted) return;
          console.warn(
            "IRMT notes lookup failed, fallback to parser flow",
            lookupError,
          );
        }
      }

      const response = await get(
        MONSTER_SEARCH_BASE_URL,
        `${IRMT_CANDIDATE_VIEW}/${candidateId}`,
        {         
          signal: controller.signal,
        },
      );
      if (controller.signal.aborted) return;
      const parsedResponse =
        typeof response === "string" ? JSON.parse(response) : response;
      console.log("Parsed Response:", parsedResponse);
      const responsePayload = parsedResponse?.response || parsedResponse || {};
      console.log("Response Payload:", responsePayload);
      const profile = responsePayload?.data || parsedResponse?.data || {};
      console.log("Profile:", profile);
      const trackHistory = responsePayload?.track_history || [];
      const transformedCandidate = transformIrmtToCandidate(
        profile,
        candidateId,
        trackHistory,
      );
      transformedCandidate.presignedUrl = profile?.presignedurl || null;
      setLocalCandidate(transformedCandidate);
      setIsProcessingView(false);
      startBackgroundIrmtResumeParsing(
        candidateId,
        profile,
        controller.signal,
        transformedCandidate,
      );
    } catch (error) {
      if (controller.signal.aborted) return;
      console.error("IRMT View Error:", error);
      Toast("error", "Failed to fetch candidate details");
    } finally {
      setIsProcessingView(false);
      setAbortController(null);
    }
  };

  return (
    <div className="irmt-search-page-wrapper">
      <div
        className="irmt-header-main-container"
        style={{
          display: "flex",
          gap: "10px",
          position: "sticky",
          justifyContent: "space-between",
          top: 0,
          zIndex: 9,
          padding: "2px 24px",
          borderBottom: "1px solid var(--header-border__color)",
          height: "59px",
          alignItems: "center",
          backgroundColor: "var(--body__background)",
          color: "var(--header__color)",
        }}
      >
        <div className="header-icon-title-container">
          <img
            alt="IRMT Icon"
            src={isDarkMode ? CandidateDarkIcon : CandidateLightIcon}
            className="header-title-icon"
          />
          <h2 className="header-container">IRMT Search</h2>
        </div>
        <div className="right-side-button-container">
          <Button
            label="Back to Vendor"
            style={{ padding: "5px 15px" }}
            event={() => navigate("/vendors")}
            iconSrc={backArrowIcon}
          />
        </div>
      </div>

      <div className="irmt-outer-main-container" style={{ padding: "20px" }}>
        <div
          className="advanced-search-toggle"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            marginBottom: "20px",
          }}
        >
          <h4
            onClick={toggleAdvancedSearch}
            className="advance-search-text"
            style={{
              cursor: "pointer",
              color: "var(--primary__color)",
              margin: 0,
            }}
          >
            {showAdvancedSearch ? "Hide Advanced Search" : "Advanced Search"}
          </h4>
          <CustomTooltip
            title={
              showAdvancedSearch
                ? "Hide Advanced Search Fields"
                : "Show More Fields For Advanced Search"
            }
            arrow
          >
            <img alt="infoIcon" src={infoIcon} style={{ width: "16px" }} />
          </CustomTooltip>
        </div>

        <form onSubmit={formik.handleSubmit} noValidate>
          <div
            style={{
              display: "grid",
              gap: "20px",
              gridTemplateColumns: "1fr 1fr 1fr",
            }}
          >
            <div style={{ flex: 1, minWidth: "250px" }}>
              <TextInput
                label="Skills"
                placeholder="e.g. JavaScript, React, Node.js"
                name="skills"
                value={formik.values.skills}
                onChange={formik.handleChange}
                required={false}
                error={formik.touched.skills && Boolean(formik.errors.skills)}
                errorMessage={formik.errors.skills}
              />
            </div>
            <div style={{ flex: 1, minWidth: "250px" }}>
              <TextInput
                label="Role"
                name="role"
                value={formik.values.role}
                onChange={formik.handleChange}
                error={formik.touched.role && Boolean(formik.errors.role)}
                errorMessage={formik.errors.role}
              />
            </div>
            <div style={{ flex: 1, minWidth: "250px" }}>
              <SelectInput
                label="Country"
                name="country"
                options={countryOptions}
                labelKey="label"
                selectStyle={{ marginTop: "5px" }}
                value={formik.values.country}
                onChange={formik.handleChange}
                required={false}
                error={formik.touched.country && Boolean(formik.errors.country)}
                errorMessage={formik.errors.country}
              />
            </div>

            <div style={{ flex: 1, minWidth: "250px" }}>
              <DynamicMultipleSelectCheckmarks
                label={
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    Location
                    {!formik.values.country && (
                      <CustomTooltip
                        title="Select a country to continue with location selection"
                        arrow
                      >
                        <img
                          alt="infoIcon"
                          src={infoIcon}
                          style={{ width: "16px", cursor: "pointer" }}
                        />
                      </CustomTooltip>
                    )}
                  </div>
                }
                name="location"
                options={locationOptions}
                labelKey="label"
                valueKey="value"
                value={formik.values.location}
                onChange={(selectedValues) =>
                  formik.setFieldValue("location", selectedValues)
                }
                placeholder={
                  !formik.values.country
                    ? "Please select a country first"
                    : "Select Location(s)"
                }
                disabled={!formik.values.country}
                required={false}
                error={
                  formik.touched.location && Boolean(formik.errors.location)
                }
                errorMessage={formik.errors.location}
              />
            </div>

            <div style={{ flex: 1, minWidth: "250px" }}>
              <DynamicMultipleSelectCheckmarks
                label={
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    Residency
                    {!formik.values.country && (
                      <CustomTooltip
                        title="Select a country to continue with residency selection"
                        arrow
                      >
                        <img
                          alt="infoIcon"
                          src={infoIcon}
                          style={{ width: "16px", cursor: "pointer" }}
                        />
                      </CustomTooltip>
                    )}
                  </div>
                }
                name="residency"
                options={residencyOptions}
                labelKey="label"
                valueKey="value"
                value={formik.values.residency}
                onChange={(selectedValues) => {
                  if (!isIndiaCountrySelected) {
                    formik.setFieldValue("residency", selectedValues);
                  }
                }}
                placeholder={
                  !formik.values.country
                    ? "Please select a country first"
                    : isIndiaCountrySelected
                      ? "Residency not applicable for India"
                      : "Select Residency(s)"
                }
                disabled={!formik.values.country || isIndiaCountrySelected}
                required={false}
                error={
                  formik.touched.residency && Boolean(formik.errors.residency)
                }
                errorMessage={formik.errors.residency}
              />
            </div>

            <div style={{ flex: 1, minWidth: "250px" }}>
              <TextInput
                label="From Date"
                type="date"
                name="fromDate"
                value={formik.values.fromDate}
                onChange={formik.handleChange}
                error={
                  formik.touched.fromDate && Boolean(formik.errors.fromDate)
                }
                errorMessage={formik.errors.fromDate}
              />
            </div>

            <div style={{ flex: 1, minWidth: "250px" }}>
              <TextInput
                label="To Date"
                type="date"
                name="toDate"
                value={formik.values.toDate}
                onChange={formik.handleChange}
                error={formik.touched.toDate && Boolean(formik.errors.toDate)}
                errorMessage={formik.errors.toDate}
              />
            </div>

            <div style={{ flex: 1, minWidth: "250px" }}>
              <SelectInput
                label="Filter By"
                name="filterby"
                options={filterByOptions}
                labelKey="label"
                value={formik.values.filterby}
                onChange={formik.handleChange}
                selectStyle={{ marginTop: "5px" }}
                error={
                  formik.touched.filterby && Boolean(formik.errors.filterby)
                }
                errorMessage={formik.errors.filterby}
              />
            </div>
            {showAdvancedSearch && (
              <>
                <TextInput
                  label="Candidate Name"
                  placeholder="Enter candidate name"
                  name="canName"
                  value={formik.values.canName}
                  onChange={formik.handleChange}
                />
                <TextInput
                  label="Candidate Email"
                  placeholder="Enter candidate email"
                  name="canEmail"
                  value={formik.values.canEmail}
                  onChange={formik.handleChange}
                />
                <PhoneNumberInput
                  label="Candidate Phone"
                  placeholder="Enter phone number"
                  value={formik.values.canPhone}
                  onChange={(phone) => {
                    formik.setFieldValue("canPhone", phone);
                  }}
                  height="41px"
                  labelStyle={{
                    fontWeight: 400,
                    marginBottom: "8px",
                    color: "var(--header__color)",
                  }}
                  required={false}
                />
                <SelectInput
                  label="Source"
                  placeholder="Select source"
                  name="canSource"
                  value={formik.values.canSource}
                  onChange={formik.handleChange}
                  options={source}
                  selectStyle={{ marginTop: "5px" }}
                />
                <SelectInput
                  label="Recruiter"
                  placeholder="Select recruiter"
                  name="recruiter"
                  value={formik.values.recruiter}
                  onChange={formik.handleChange}
                  options={recruiterOptions}
                  labelKey="label"
                  valueKey="value"
                  selectStyle={{ marginTop: "5px" }}
                />
                <SelectInput
                  label="Call Stage"
                  placeholder="Select call stage"
                  name="callStage"
                  value={formik.values.callStage}
                  onChange={formik.handleChange}
                  options={callStageOptions}
                  labelKey="label"
                  valueKey="value"
                  selectStyle={{ marginTop: "5px" }}
                />
                <TextInput
                  label="Job Openings"
                  placeholder="Enter job Openings"
                  name="jobOpenings"
                  value={formik.values.jobOpenings}
                  onChange={formik.handleChange}
                />
                <SelectInput
                  label="Candidates by Timeframe Selection"
                  name="yearsOfExperience"
                  options={timeframeOptions}
                  labelKey="label"
                  value={formik.values.yearsOfExperience}
                  onChange={formik.handleChange}
                  selectStyle={{ marginTop: "5px" }}
                />
                <SelectInput
                  label="Exp From Month"
                  placeholder="Select Month"
                  name="expFromMonth"
                  options={monthOptions}
                  labelKey="label"
                  value={formik.values.expFromMonth}
                  onChange={formik.handleChange}
                  selectStyle={{ marginTop: "5px" }}
                />
                <SelectInput
                  label="Exp From Year"
                  placeholder="Select Year"
                  name="expFromYear"
                  options={yearOptions}
                  labelKey="label"
                  value={formik.values.expFromYear}
                  onChange={formik.handleChange}
                  selectStyle={{ marginTop: "5px" }}
                />
                <SelectInput
                  label="Exp To Month"
                  placeholder="Select Month"
                  name="expToMonth"
                  options={monthOptions}
                  labelKey="label"
                  value={formik.values.expToMonth}
                  onChange={formik.handleChange}
                  selectStyle={{ marginTop: "5px" }}
                />
                <SelectInput
                  label="Exp To Year"
                  placeholder="Select Year"
                  name="expToYear"
                  options={yearOptions}
                  labelKey="label"
                  value={formik.values.expToYear}
                  onChange={formik.handleChange}
                  selectStyle={{ marginTop: "5px" }}
                />
              </>
            )}
          </div>

          <div
            style={{
              marginTop: "40px",
              display: "flex",
            }}
          >
            <Button
              label={isLoading ? "Searching..." : "Search IRMT Candidates"}
              type="submit"
              disabled={isLoading}
            />
          </div>
        </form>

        <div className="results-container" style={{ marginTop: "50px" }}>
          {isLoading ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <VybogTALLoaderAnimation />
            </div>
          ) : hasSearched && results.length > 0 ? (
            <div
              className="candidates-grid"
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
                gap: "20px",
              }}
            >
              {results.map((candidate, index) => {
                const isLast = index === results.length - 1;
                return (
                  <div
                    key={candidate.can_id || index}
                    ref={isLast ? lastIrmtCardRef : null}
                  >
                    <Card
                      name={candidate.can_name}
                      role={candidate.role || candidate.designation || "N/A"}
                      experience={candidate.can_exp_year || "N/A"}
                      location={
                        candidate.city ||
                        candidate.location ||
                        candidate.country_name ||
                        "N/A"
                      }
                      skills={
                        candidate.skill
                          ? candidate.skill
                              .split(",")
                              .map((s) => s.trim())
                              .filter(Boolean)
                          : candidate.skills || []
                      }
                      showView={true}
                      viewEvent={() => handleViewCandidate(candidate)}
                      cardbackgroundColor="var(--card__background)"
                      cardColor="var(--header__color)"
                      skillbackgroundColor="var(--skill-badge-bg)"
                      skillColor="var(--skill-badge-color)"
                    />
                  </div>
                );
              })}

              {isLoadingMore && (
                <>
                  {Array.from({ length: 10 }).map((_, index) => (
                    <DynamicSkeleton
                      key={index}
                      variant="rectangular"
                      dimensions={{
                        width: "100%",
                        height: "170px",
                        sx: { borderRadius: "16px" },
                      }}
                    />
                  ))}
                </>
              )}

              {!hasMore && results.length > 0 && (
                <div
                  style={{
                    textAlign: "center",
                    width: "100%",
                    color: "#666",
                    marginTop: 12,
                  }}
                >
                  <p>No more candidates to load</p>
                </div>
              )}
            </div>
          ) : hasSearched && results.length === 0 ? (
            <div style={{ textAlign: "center", marginTop: "30px" }}>
              <h3>No candidates found</h3>
              <AnimationPlayer
                animationSrc={NoDataFound}
                playerHeight="250px"
                playerWidth="250px"
              />
            </div>
          ) : null}
        </div>
      </div>

      <SidePopup
        isOpen={isPopupOpen}
        onClose={handlePopupClose}
        title="Candidate Details"
        sidePopupWidth={"82%"}
      >
        {isProcessingView ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "80vh",
            }}
          >
            <VybogTALLoaderAnimation />
          </div>
        ) : (
          localCandidate && (
            <CandidateDetailsContainer
              candidate={localCandidate}
              activeTab={0}
              handleTabChange={() => {}}
              hasSearched={true}
              isEditingCandidate={isEditingCandidate}
              handleEditCandidate={handleEditCandidate}
              saveCandidateChanges={saveCandidateChanges}
              resetCandidateEdit={resetCandidateEdit}
              handleCandidateChange={handleCandidateChange}
              editedCandidateData={editedCandidateData}
              isVendorFeatureEnabled={isVendorFeatureEnabled}
              vendorList={vendorList}
              vendorOptionLoading={vendorOptionLoading}
              handleVendorInputChange={handleVendorInputChange}
              assignedVendor={assignedVendor}
              hasCandidateId={hasCandidateId}
              candidateId={realCandidateId}
              failedDueToMissingData={isImportFailed}
            />
          )
        )}
      </SidePopup>
    </div>
  );
}

export default IrmtSearch;
